<template>
   <v-overlay
          absolute
          class="d-flex flex-column text-center"
          opacity="0.35"
          z-index="1"
          :value="condition"
        >
          <div>
            <v-progress-circular
              width="2"
              size="50"
              color="white"
              indeterminate
            >
              <v-icon size="30">mdi-timer-sand</v-icon>
            </v-progress-circular>
          </div>
        </v-overlay>
</template>

<script>
export default {
props:{
    condition: Boolean
}
}
</script>

<style>

</style>